<template>
  <div id="sitelogin">
    <div class="loginbox" v-loading="loading">
      <div class="titlebox">
        <span>{{ shop_name || "" }}</span>
        <span>客服登录后台</span>
      </div>

      <div class="inputbox" style="margin-bottom: 40px">
        <div class="label">登录账号</div>
        <el-input
          type="text"
          style="input"
          v-model="user_name"
          placeholder="请输入账号"
        ></el-input>
      </div>

      <div class="inputbox">
        <div class="label">登录密码</div>
        <el-input
          type="password"
          style="input"
          v-model="password"
          placeholder="请输入密码"
        ></el-input>
      </div>

      <el-button class="loginbtn" type="primary" @click="login">登录</el-button>
    </div>
  </div>
</template>

<script>
import { eltips, getUrlKey } from "@/util/util.js";
import { resetRouter } from "@/router/index.js";
import { adminroutes } from "@/router/apps/service.js";
import store from "@/store/index.js";
export default {
  name: "servicelogin",
  data() {
    return {
      shop_name: "",
      user_name: "", //用户名
      password: "", //密码
      guard_name: "enterprise_law_service_user", //应用名称
      shop_id: "22201480",
      loading: false,
    };
  },
  created() {
    if (getUrlKey("name")) {
      this.shop_name = getUrlKey("name");
    }

    if (getUrlKey("shop_id")) {
      this.shop_id = getUrlKey("shop_id");
    }

    if (getUrlKey("guard_name")) {
      this.guard_name = getUrlKey("guard_name");
    }
    sessionStorage.setItem("guardName", "enterprise_law_service_user");
  },
  methods: {
    //登录
    login() {
      if (!this.user_name) {
        eltips("请输入账号", "error");
        return;
      }
      if (!this.password) {
        eltips("请输入密码", "error");
        return;
      }

      let data = {
        shop_id: this.shop_id,
        phone: this.user_name,
        password: this.password,
      };
      if (this.guard_name) {
        data.guard_name = this.guard_name;
      }

      this.axios.post("/api/enterprise_law/service_login", data).then((res) => {
        if (res.code == 200) {
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("userSig", res.data.usersig);
          sessionStorage.removeItem("role_id");
          sessionStorage.removeItem("pluginroute");
          sessionStorage.removeItem("pluginid");
          this.getuserinfo();
        } else {
          eltips(res.msg, "error");
        }
      });
    },
    getuserinfo() {
      this.axios
        .get("/api/enterprise_law/service_admin/user_info")
        .then((res) => {
          if (res.code == 200) {
            sessionStorage.setItem("userinfo", JSON.stringify(res.data));
            this.getmeuns();
            this.timlogin()
          } else {
            this.loading = false;
            eltips(res.msg, "error");
          }
        });
    },
    getmeuns() {
      sessionStorage.removeItem("routestext");
      sessionStorage.removeItem("routes");
      sessionStorage.setItem("routes", JSON.stringify(adminroutes));
      this.$router.replace({ path: "/chart" });
      this.loading = false;
    },
    timlogin() {
      this.$tim
        .login({
          userID: JSON.parse(sessionStorage.getItem("userinfo")).im_account,
          userSig: sessionStorage.getItem("userSig"),
        })
        .then((res) => {
          console.log(res);
        });
    },
  },
};
</script>


<style>
#sitelogin .el-input__inner {
  border: none !important;
}

#sitelogin .el-button {
  padding: 18px 20px !important;
  font-size: 16px;
  font-weight: bold;
}
</style>
<style scoped lang="less">
#sitelogin {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: url(../../../../assets/images/login_bg.png);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.1);
  .loginbox {
    width: 380px;
    background: #ffffff;
    border-radius: 20px;
    padding: 30px;
  }
  .titlebox {
    font-size: 20px;
    color: #1e92ff;
    margin-bottom: 40px;
    font-weight: bold;
  }
  .inputbox {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dedede;
    padding-bottom: 6px;
    .label {
      width: 80px;
    }
    .input {
    }
  }
  .loginbtn {
    margin-top: 100px;
    width: 100%;
  }
}
</style>
